import { render, staticRenderFns } from "./trialpay.vue?vue&type=template&id=b025a796&scoped=true&"
import script from "./trialpay.vue?vue&type=script&lang=js&"
export * from "./trialpay.vue?vue&type=script&lang=js&"
import style0 from "./trialpay.vue?vue&type=style&index=0&id=b025a796&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b025a796",
  null
  
)

export default component.exports